import createIcon from '../../createIcon';

/**
 * @component @name LineStyle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxNkg4VjE0SDNWMTZaTTkuNSAxNkgxNC41VjE0SDkuNVYxNlpNMTYgMTZIMjFWMTRIMTZWMTZaTTMgMjBINVYxOEgzVjIwWk03IDIwSDlWMThIN1YyMFpNMTEgMjBIMTNWMThIMTFWMjBaTTE1IDIwSDE3VjE4SDE1VjIwWk0xOSAyMEgyMVYxOEgxOVYyMFpNMyAxMkgxMVYxMEgzVjEyWk0xMyAxMkgyMVYxMEgxM1YxMlpNMyA0VjhIMjFWNEgzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LineStyle = createIcon('LineStyle', [
  [
    'path',
    {
      d: 'M3 16H8V14H3V16ZM9.5 16H14.5V14H9.5V16ZM16 16H21V14H16V16ZM3 20H5V18H3V20ZM7 20H9V18H7V20ZM11 20H13V18H11V20ZM15 20H17V18H15V20ZM19 20H21V18H19V20ZM3 12H11V10H3V12ZM13 12H21V10H13V12ZM3 4V8H21V4H3Z',
      key: 'wz0ibt',
    },
  ],
]);

export default LineStyle;
